import jsSHA from 'jssha';
import Cookies from 'js-cookie';
import { pubSub } from '@utils/PubSub';
export default class EmailCapture {
  constructor(context) {
    this.elements = {
      $emailCapture: context,
      $ecapform: context.querySelector('.email-capture'),
      $submit: context.querySelector('.email-input--submit'),
      $inputWrapper: context.querySelector('.input-wrapper'),
      $response: document.querySelector('.email-response'),
    };
    this.initCCPA();
  }

  validateInput(currentEl) {
    // validate email and phone number input
    const inputType = currentEl.type,
      { $ecapform } = this.elements,
      validationRegex = {
        tel: /^1? ?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      };

    const passedValidation = () => validationRegex[inputType].test(currentEl.value);

    if (passedValidation()) {
      //console.log('passed validation');
      let validValue = inputType == 'tel' ? parseInt(inputEl.value.replace(/\D/g, '')) : currentEl.value;
      this.subscribeEmail(
        $ecapform,
        () => {
          this.emailDone();
        },
        validValue
      );
      const nanoText = window.Brooklinen?.partial[0].nano?.text;
      if (nanoText) this.updateNanoText(nanoText);
    } else this.outputError(inputType, currentEl);
  }

  updateNanoText(text) {
    let expires = '';

    const optInDeadline = window.Brooklinen?.nano?.[0]?.settings.opt_in_slide_expiration;
    let date, expired;
    if (optInDeadline) {
      const currentDate = new Date();
      date = new Date(optInDeadline);
      expired = date.getTime() < currentDate.getTime();
    } else {
      expired = false;
      date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
    }

    if (!expired) {
      expires = '; expires=' + date.toUTCString();
      document.cookie = `_dy_nano_updated=${text}; expires=${expires}; path=/`;

      pubSub.publish('nudge:submitted');
    }
  }
  outputError(inputType, currentEl) {
    // depending on input type, add the appropriate text to error label
    let errorText = '';
    if (inputType == 'tel') {
      errorText = 'Enter a valid phone number';
    } else if (inputType == 'emailExists') {
      errorText = 'Oops! That email address is already in use.';
    } else {
      errorText = 'Enter a valid email address.';
    }
    const { $ecapform } = this.elements,
      inputEl = currentEl,
      errorLabel = $ecapform.querySelector('.email-input--message');
    inputEl.classList.add('error');
    errorLabel.innerHTML = errorText;
    errorLabel.ariaHidden = false;
  }

  submitInputFields() {
    let emailInput = document.querySelector('.email-input');
    let emailVal = emailInput.value;
    let { $ecapform } = this.elements;
    if (emailVal.length > 0) {
      this.validateInput(document.querySelector('.email-input'));
      $ecapform.classList.add('email-capture--loading');
    }
  }

  setGatedCookie() {
    const cookieName = window?.Brooklinen?.themeSettings?.gatedCookie?.name;
    const expiration = window?.Brooklinen?.themeSettings?.gatedCookie?.expiration ? new Date(window?.Brooklinen?.themeSettings?.gatedCookie?.expiration) : null;
    Cookies.set(cookieName, true, {
      expires: expiration,
    });
  }

  emailDone() {
    let { $inputWrapper, $response, $ecapform } = this.elements;
    $inputWrapper.classList.add('hide');
    $response.classList.remove('hide');
    $ecapform.classList.remove('email-capture--loading');
    if (window?.Brooklinen?.themeSettings?.gatedCookie) this.setGatedCookie();
  }

  subscribeEmail(form, callback, email) {
    let { $ecapform } = this.elements;
    const formContext = $ecapform.dataset.formContext;
    const utmSrc = window?.Brooklinen?.getUrlData() || {};
    const signupSrc = formContext;
    const props = { signup_source: signupSrc, ...utmSrc };
    const timeStamp = new Date();

    const payload = {
      '@type': 'contact',
      '@collection': signupSrc,
      email: email,
      '@merge': true,
      marketing_optin: 'EXPLICITLY_OPTEDIN',
      timestamp_subscribed: timeStamp.toISOString(),
      properties: props,
    };

    fetch(window.Brooklinen?.ometriaEndpoint, {
      method: 'POST',
      dataType: 'json',
      mode: 'cors',
      contentType: 'application/json; charset=utf-8',
      headers: {
        'X-Brooklinen-Auth': '0acf4539a14b3aa27deeb4cbdf6e989f',
        'content-type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        let shaObj = new jsSHA('SHA-256', 'TEXT');
        shaObj.update(email.toLowerCase());
        let emailHash = shaObj.getHash('HEX');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          submittedEmail: emailHash,
        });

        //Used for Ometria identify in GTM
        dataLayer.push({
          event: 'dl_subscribe',
          formLocation: signupSrc,
        });

        const emailAlreadyExists = !(data?.ometria_contact === 'created' || (data?.ometria_contact_created && data?.shopify_contact_created));
        if (!emailAlreadyExists || !window?.Brooklinen?.ometriaErrorHandling) {
          try {
            heap.track('Email Optin', {
              email: email,
              signup_source: signupSrc,
            });
          } catch (e) {
            console.log(`Heap error ${e}`);
          }
          callback(email);
        } else {
          document.querySelector('.email-capture').classList.remove('email-capture--loading');
          this.outputError('emailExists', document.querySelector('.email-input'));
        }
      });
  }

  initCCPA() {
    let { $submit } = this.elements;
    // The button that submits the form
    $submit.addEventListener('click', (e) => {
      e.preventDefault();
      this.submitInputFields();
    });
  }
}
